/**
 * Minimal dot/array-index path helpers for the service-page editor.
 * Path example: "whatWeBuild.cards.2.title"
 */

function parsePath(path) {
  return String(path || '')
    .split('.')
    .filter((seg) => seg !== '');
}

export function getByPath(obj, path) {
  const segs = parsePath(path);
  let cur = obj;
  for (const seg of segs) {
    if (cur == null) return undefined;
    cur = cur[seg];
  }
  return cur;
}

/** Immutable set — clones every object/array along the path, leaves siblings untouched. */
export function setByPath(obj, path, value) {
  const segs = parsePath(path);
  if (!segs.length) return obj;

  const clone = (node, isArrayNext) => {
    if (Array.isArray(node)) return [...node];
    if (node && typeof node === 'object') return { ...node };
    return isArrayNext ? [] : {};
  };

  const root = clone(obj, /^\d+$/.test(segs[0]));
  let cur = root;
  for (let i = 0; i < segs.length - 1; i += 1) {
    const seg = segs[i];
    const nextIsArrayIndex = /^\d+$/.test(segs[i + 1]);
    const existing = cur[seg];
    cur[seg] = clone(existing, nextIsArrayIndex);
    cur = cur[seg];
  }
  cur[segs[segs.length - 1]] = value;
  return root;
}
